<template>
  <div class="answers_date" v-on-click-away="hide_picker">
    <masked-input
      :mask="[
        /[0-3]/,
        /[0-9]/,
        '-',
        /[0-1]/,
        /[0-9]/,
        '-',
        /[1-2]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/
      ]"
      type="text"
      :class="['date', { error: !valid }]"
      v-model="date"
      :keepCharPositions="true"
      :placeholder="$tr(placeholder)"
      @input="set_date"
      @focus="open_picker"
    />

    <calendar
      v-if="show_picker"
      class="date-range"
      :show-lunar="false"
      :first-day-of-week="1"
      :lang="current_locale"
      @change="change"
    />
  </div>
</template>

<script>
  import Moment from 'moment';
  import MaskedInput from 'vue-text-mask';
  import { Calendar } from 'vue-date-range';
  import { directive as VueClickAway } from 'vue-clickaway';
  import isMobile from 'ismobilejs';

  export default {
    name: 'answers_date',

    components: {
      Calendar,
      MaskedInput
    },

    directives: {
      onClickAway: VueClickAway
    },

    props: [
      'data',
      'current_locale',
      'id',
      'hide_mobile_calend',
      'placeholder'
    ],

    data() {
      return {
        show_picker: false,
        date: '',
        isMobile: isMobile.any,
        oldVal: null
      };
    },

    watch: {
      valid(v) {
        this.$emit('set_valid_date', v);
      },
      hide_mobile_calend(v) {
        if (v) {
          this.show_picker = false;
        }
      }
    },

    computed: {
      valid() {
        if (this.date[0] === '3') {
          return this.date[1] <= 1 || this.date[1] === '_';
        } else if (this.date[3] === '1') {
          return this.date[4] <= 2 || this.date[4] === '_';
        } else {
          return true;
        }
      }
    },

    methods: {
      change(v) {
        this.date = Moment(v).format('DD-MM-YYYY');
        this.oldVal = this.date;

        this.$emit('update', {
          question_id: this.id,
          date: this.date
        });
      },

      set_date(v) {
        if (v === this.oldVal) {
          return;
        }
        if (v) {
          this.show_picker = true;
          this.$emit('set_mobile_calend', false);
        }
        this.date = v;
        this.oldVal = this.date;

        this.$emit('update', {
          question_id: this.id,
          date: this.date
        });
      },

      open_picker() {
        if (this.show_picker) return;

        this.show_picker = true;
        this.$emit('set_mobile_calend', false);
      },

      hide_picker() {
        if (!this.show_picker) return;

        this.show_picker = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .answers_date {
    position: relative;
    width: 230px;

    .date {
      width: 150px;
      max-height: 40px;
      min-height: 40px;
      border: 1px solid #d2d6e0;

      &.error {
        border: 1px solid #f65046;
      }
    }

    .date-range {
      position: absolute;
      top: calc(100% + 5px);
      left: 0;
      border-radius: 2px;
      border: 1px solid #d2d6e0;
      background: #ffffff;
      z-index: 9;
    }

    ::v-deep {
      .v-date-cell .v-date-cell-text {
        transform: translate(-50%, -32%);
      }
    }
  }
</style>
